import { safeReadingTags } from "./reading-diagnostics.mjs";
export { safeReadingTags } from "./reading-diagnostics.mjs";
// Reading errors retain only diagnostic metadata. Never mutate SDK scopes.
type EventLike = { tags?: Record<string, unknown>; request?: { url?: string }; message?: string; type?: unknown; event_id?: string; timestamp?: number; platform?: string; level?: unknown; environment?: string; release?: string };
export const isReadingUrl = (url: string) => /(?:\/api\/reading(?:\/|\?)|\/reading(?:\?|$)|[?&]activity=reading(?:&|$))/.test(url);
export function sanitizeReadingEvent<T extends EventLike>(event: T, active = false): T {
  if (!active && event.tags?.flow !== "reading" && !isReadingUrl(event.request?.url ?? "")) return event;
  return {
    type: event.type, event_id: event.event_id, timestamp: event.timestamp, platform: event.platform,
    level: event.level, environment: event.environment, release: event.release,
    message: /^[a-z_]+$/.test(event.message ?? "") ? event.message : "reading_error", tags: safeReadingTags(event.tags), fingerprint: [event.message && /^[a-z_]+$/.test(event.message) ? event.message : "reading_error", safeReadingTags(event.tags).reason ?? "unknown"],
  } as unknown as T;
}
export function sanitizeReadingBreadcrumb<T extends { category?: string; data?: Record<string, unknown> }>(crumb: T, active = false): T | null {
  if (active || isReadingUrl(String(crumb.data?.url ?? ""))) return null;
  return crumb;
}
